// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

function getDate(data = '') {
    
var today = new Date();
                var dd = today.getDate();
                
                var mm = today.getMonth()+1; 
                var yyyy = today.getFullYear();
                if(dd<10) 
                {
                    dd='0'+dd;
                } 
                
                if(mm<10) 
                {
                    mm='0'+mm;
                } 
                  today = yyyy+'-'+mm+'-'+dd;
      return today;
}

function priceFormat(params) {
  var price = parseFloat(params) / 100;
  return price.toFixed(2)
}

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt);
  jQuery.getJSON('/cart.js', function(cart) {
     // console.log(cart)
    add_to_cart(cart, evt)
  });
  
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  function setCartAttributes(attributes = {}) {
    const result = fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            attributes: attributes 
        })
    });

    return result;
}
  let rfc = document.getElementById("rfc");
  let cfdi = document.getElementById("cart-cfdi");
  let uso = document.getElementById("cart-uso");
  var attr = {
    FRC: rfc,
    CFDI: cfdi,
    USO_CFDI: uso
  }
  let cart = setCartAttributes(attr); 
  // console.log(cart.attributes)


}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

document.addEventListener("product:quantity-update", function (evt) {
    console.log("Product quantity updated");
 // location.reload();
});

function add_to_cart(cart, evt)
{
    const options = {
        method: "GET"
    };

    fetch("https://ninewest.engranedigital.com/products/index.php?prod="+evt.detail.product.product_id, options)
    .then(response => response.text())
    .then(data => {
        const item = JSON.parse(data);
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
            'cart_id': cart.token,
            'date_created__cart': today,
            'date_update__cart': today,
            'total_quantity_cart': cart.item_count,
            'total_price_cart': priceFormat(cart.total_price),
            'items': 
                [{
                    'item_name'              : evt.detail.product.product_title,
                    'item_id'                : evt.detail.product.product_id,
                    'price'                  : priceFormat(evt.detail.product.price),
                    'price_without_discount' : item.compare_at_price,
                    'discount'               : item.discount,
                    'item_brand'             : evt.detail.product.vendor,
                    'item_category'          : evt.detail.product.product_type,
                    'item_category2'         : '',
                    'silueta'                : '',
                    'tacon'                  : '',
                    'item_variant'           : evt.detail.product.variant_options[0] + ' - ' + evt.detail.product.variant_options[2],
                    'size'                   : evt.detail.product.variant_options[1],
                    'is_in_stock'            : 'Yes',
                    'image'                  : evt.detail.product.image,
                    'quantity'               : evt.detail.product.quantity,
                    'index'                  : '',
                    'currency'               : 'MXN',
                    'type'                   : item.type,
                    'is_on_sale'             : item.is_on_sale,
                    'added_date'             : today,
                }]
            }
        });
    });
}

